<app-loader *ngIf="isLoading"></app-loader>
<div class="login">
  <!-- Header moderne avec navigation -->
  <header class="modern-header">
    <div class="header-container">
      <!-- Logo -->
      <div class="header-logo">
        <img src="/logo.png" alt="Educanet Logo" />
      </div>

      <!-- Navigation -->
      <nav class="header-nav">
        <!-- Menu Produits -->
        <div class="nav-item dropdown-container">
          <button class="nav-button" (click)="toggleDropdown('produits')">
            {{ 'homepage.navigation.products' | translate }} <span class="dropdown-arrow">▼</span>
          </button>
          <div class="dropdown-menu" *ngIf="activeDropdown === 'produits'">
            <a href="https://9issati.net/" target="_blank" class="dropdown-item">9issati</a>
            <a href="https://mon-compte.rafi9ni.pro/" target="_blank" class="dropdown-item">Rafi9ni</a>
          </div>
        </div>

        <!-- Menu Social -->
        <div class="nav-item dropdown-container">
          <button class="nav-button" (click)="toggleDropdown('social')">
            {{ 'homepage.navigation.social' | translate }} <span class="dropdown-arrow">▼</span>
          </button>
          <div class="dropdown-menu" *ngIf="activeDropdown === 'social'">
            <a href="https://www.facebook.com/educanet.pro/" target="_blank" class="dropdown-item">
              Facebook
            </a>
            <a href="https://www.instagram.com/educanet_tunisie/" target="_blank" class="dropdown-item">
              Instagram
            </a>
            <a href="https://www.tiktok.com/@educanettn" target="_blank" class="dropdown-item">
              TikTok
            </a>
          </div>
        </div>

        <!-- Menu Contact -->
        <div class="nav-item">
          <a routerLink="/contact" class="nav-button">{{ 'homepage.navigation.contact' | translate }}</a>
        </div>

        <!-- Menu Accueil -->
        <div class="nav-item">
          <a href="https://www.educanet.tn/" class="nav-button" target="_blank">{{ 'homepage.navigation.home' |
            translate }}</a>
        </div>

        <!-- Bouton Traduction (Langue) -->
        <div class="nav-item langue language-dropdown">
          <button type="button" class="nav-button" (click)="isLanguageDropdownOpen = !isLanguageDropdownOpen">
            <img [src]="getCurrentLanguageFlag()" width="20" class="mr-2" alt="flag" />
            <span class="dropdown-arrow">▼</span>
          </button>

          <div class="dropdown-menu" *ngIf="isLanguageDropdownOpen">
            <button class="dropdown-item" (click)="selectLanguage('fr')">
              <img src="https://flagcdn.com/w20/fr.png" width="20" class="mr-2" alt="fr" />
              {{ 'homepage.language.french' | translate }}
            </button>
            <button class="dropdown-item" (click)="selectLanguage('en')">
              <img src="https://flagcdn.com/w20/gb.png" width="20" class="mr-2" alt="en" />
              {{ 'homepage.language.english' | translate }}
            </button>
            <button class="dropdown-item" (click)="selectLanguage('ar')">
              <img src="https://flagcdn.com/w20/tn.png" width="20" class="mr-2" alt="ar" />
              {{ 'homepage.language.arabic' | translate }}
            </button>
          </div>
        </div>
      </nav>
    </div>
  </header>

  <!-- Background SVG -->
  <svg class="group-44305" width="1605" height="312" viewBox="0 0 1605 312" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1605 0H0.314453V312C45.2917 260.711 90.9506 142.868 465.885 120C824.402 98.1333 1335.51 92.7111 1605 98.1333V0Z"
      fill="url(#paint0_linear_1097_7195)" />
    <defs>
      <linearGradient id="paint0_linear_1097_7195" x1="802.657" y1="0" x2="802.657" y2="312"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CDFC9C" />
        <stop offset="0.572115" stop-color="#C3DBF7" />
      </linearGradient>
    </defs>
  </svg>

  <div class="rectangle-84"></div>
  <div class="welcome-back">
    <span>
      <span class="welcome-back-span">
        {{ "homepage.loginForm.welcomeBack" | translate }}</span>
    </span>
  </div>

  <div>
    <form class="space-y-6 min-h-[300px]" (ngSubmit)="handleSubmit()" #loginForm="ngForm">
      <div class="group-225">
        <div>
          <input type="text" [(ngModel)]="email" name="email" required
            placeholder="{{ 'homepage.loginForm.username' | translate }}" aria-label="Enter your User name"
            class="overlay-input" style="left: 16.01%; width: 29.53%; top: calc(50% - 102.14px)" />
        </div>
        <div class="username">
          {{ "homepage.loginForm.username" | translate }}
        </div>
      </div>
      <div class="group-227">
        <div class="group-226">
          <div class="password-wrapper" style="
              left: 16.01%;
              width: 29.53%;
              top: calc(50% - 10.08px);
              position: absolute;
              height: 41.42px;
              z-index: 11;
            ">
            <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" name="password" required
              placeholder="{{ 'homepage.loginForm.password' | translate }}" aria-label="Enter your Password"
              class="overlay-input" style="
                width: 100% !important;
                height: 100% !important;
                position: relative !important;
                top: 0 !important;
                left: 0 !important;
                padding-right: 45px !important;
              " />

            <button type="button" class="password-toggle-btn" [attr.aria-label]="
                showPassword ? 'Hide password' : 'Show password'
              " (click)="togglePassword(); $event.stopPropagation()">
              <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5C7 5 2.73 8.11 1 12C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 12C21.27 8.11 17 5 12 5Z"
                  stroke="#49bbbd" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="12" cy="12" r="3" stroke="#49bbbd" stroke-width="1.2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M17.94 17.94C16.24 19.06 14.19 19.74 12 19.74C7 19.74 2.73 16.63 1 12.74" stroke="#49bbbd"
                  stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3 3L21 21" stroke="#49bbbd" stroke-width="1.2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>

          <div class="password">
            {{ "homepage.loginForm.password" | translate }}
          </div>
        </div>
      </div>
      <div *ngIf="errorMessage" class="text-red-500" style="
          position: absolute;
          top: 53% !important;
          left: 23%;
          font-size: 10px;
        ">
        {{ errorMessage }}
      </div>

      <!-- Remember me checkbox (placed under labels) -->
      <div class="remember-container">
        <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" id="rememberMe"
          [attr.aria-label]="'homepage.loginForm.rememberMe' | translate" />
        <label for="rememberMe">{{
          "homepage.loginForm.rememberMe" | translate
          }}</label>
      </div>

      <button class="interactive-overlay" type="submit">
        {{ "homepage.loginForm.login" | translate }}
      </button>
    </form>
  </div>
  <svg class="group-44304" width="1600" height="485" viewBox="0 0 1600 485" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 485V314.832C104.815 314.832 436.856 333.882 894.444 283.327C1363.89 231.463 1549.63 78.7973 1600 0V485H0Z"
      fill="url(#paint0_linear_1097_7194)" />
    <defs>
      <linearGradient id="paint0_linear_1097_7194" x1="800" y1="0" x2="800" y2="485" gradientUnits="userSpaceOnUse">
        <stop offset="0.524038" stop-color="#C2F994" />
        <stop offset="1" stop-color="#94BCEB" />
      </linearGradient>
    </defs>
  </svg>
  <div class="ellipse-18"></div>

  <img class="teacher-students-classroom-1" style="
      width: 441.48px;
      height: 433.9px;
      right: 100.1px;
      animation: float 3s ease-in-out infinite;
    " [src]="getHeroImage()" />

  <!-- Footer Moderne Image Match -->
  <footer class="modern-footer">
    <div class="footer-container-row">
      <!-- Logo à gauche -->
      <div class="footer-left">
        <img src="/logo.png" alt="Educanet" class="footer-logo-img" />
      </div>

      <!-- Texte au centre -->
      <div class="footer-center-text">
        {{ 'homepage.supportingText' | translate }}
      </div>

      <!-- Copyright et icônes à droite -->
      <div class="footer-right-side">
        <span class="footer-copy">{{ 'homepage.footer.copyright' | translate }}</span>
        <div class="footer-socials">
          <a href="https://www.facebook.com/educanet.pro/" target="_blank" class="social-icon-btn">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/educanet_tunisie/" target="_blank" class="social-icon-btn">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.tiktok.com/@educanet" target="_blank" class="social-icon-btn">
            <i class="fab fa-tiktok"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</div>